import React from 'react';

/**
 * RiskIndicator - Visual badge showing risk level
 * Used throughout the boundary monitoring dashboard
 */
const RiskIndicator = ({ level, size = 'medium', showLabel = true }) => {
  const levels = {
    critical: { color: '#dc3545', bgColor: '#f8d7da', label: 'Critical' },
    high: { color: '#fd7e14', bgColor: '#ffe5d0', label: 'High' },
    medium: { color: '#ffc107', bgColor: '#fff3cd', label: 'Medium' },
    low: { color: '#28a745', bgColor: '#d4edda', label: 'Low' },
    normal: { color: '#6c757d', bgColor: '#e9ecef', label: 'Normal' }
  };

  const sizes = {
    small: { padding: '2px 6px', fontSize: '11px', dotSize: '6px' },
    medium: { padding: '4px 10px', fontSize: '12px', dotSize: '8px' },
    large: { padding: '6px 14px', fontSize: '14px', dotSize: '10px' }
  };

  const config = levels[level] || levels.normal;
  const sizeConfig = sizes[size] || sizes.medium;

  const style = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    padding: sizeConfig.padding,
    backgroundColor: config.bgColor,
    color: config.color,
    borderRadius: '12px',
    fontSize: sizeConfig.fontSize,
    fontWeight: '600',
    border: `1px solid ${config.color}`,
  };

  const dotStyle = {
    width: sizeConfig.dotSize,
    height: sizeConfig.dotSize,
    backgroundColor: config.color,
    borderRadius: '50%',
  };

  return (
    <span style={style}>
      <span style={dotStyle}></span>
      {showLabel && config.label}
    </span>
  );
};

export default RiskIndicator;
